import { useFeatureFlags } from '../../../featureQuery';
import { FeatureFlagKeys } from '../../../interfaces';

/**
 * Custom hook to check if the LQA Checkout Card feature is enabled
 * @returns Boolean indicating if the feature flag is enabled
 */
export const useCheckoutCardFeatureFlag = (): boolean => {
  const { getSingleFlag } = useFeatureFlags();
  return getSingleFlag(FeatureFlagKeys.LQACheckoutCard);
};
